'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orderListItems = exports.listItemIndex = exports.findActionCreated = undefined;

var _orderBy2 = require('lodash/fp/orderBy');

var _orderBy3 = _interopRequireDefault(_orderBy2);

var _keyBy2 = require('lodash/fp/keyBy');

var _keyBy3 = _interopRequireDefault(_keyBy2);

var _find2 = require('lodash/fp/find');

var _find3 = _interopRequireDefault(_find2);

var _mapValues2 = require('lodash/mapValues');

var _mapValues3 = _interopRequireDefault(_mapValues2);

exports.getLiCollection = getLiCollection;
exports.setLiCollection = setLiCollection;
exports.setListItemsCollection = setListItemsCollection;

var _reduxGraph = require('redux-graph');

var _const = require('./const');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Returns first found item that is created.


var findActionCreated = exports.findActionCreated = (0, _find3.default)({
  actionStatus: _const.CREATED
});
var listItemIndex = exports.listItemIndex = (0, _keyBy3.default)('item.id');
var orderListItems = exports.orderListItems = (0, _orderBy3.default)(['position', 'item.id'], 'asc');

function getLiCollection(listItem) {
  return (0, _reduxGraph.val0)(listItem.domainIncludes[_const.PREDICATE]);
}

function setLiCollection(listItem) {
  return listItem.set('collection', getLiCollection(listItem)).without('domainIncludes');
} // Move domainIncludes.PREDICATE to collection.


function setListItemsCollection(listItems) {
  return (0, _mapValues3.default)(listItems, setLiCollection);
}